const ONLINE = 'ONLINE'
const OFFLINE = 'OFFLINE'

const initialState = {
  online: true
}

const state = { ...initialState }

const mutations = {
  [ONLINE]: function (state, payload) {
    state.online = true
  },
  [OFFLINE]: function (state) {
    state.online = false
  }
}

const actions = {
  setOnline ({ commit }) {
    commit(ONLINE)
  },
  setOffline ({ commit }) {
    commit(OFFLINE)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
